const businessPageDataAr = {
  header : {
      image : {
          name : "business.jpg",
          alt : "Business Strategy wallpaper",
      },
  },
  mainTitle : "استراتيجية أعمالنا التي تركز على الممارسات البيئية والاجتماعية والحوكمة المؤسسية",
  paragraphOne : "بالتزامن مع الإعلان عن مبادرة السعودية الخضراء والإقرار الرسمي للمساهمات المحددة وطنيًا التي قدمتها المملكة في مؤتمر الأطراف السادس والعشرين المعني بتغير المناخ في العام 2021، أعددنا في بنك الأول استراتيجية طموحة لدعم مبادرات للممارسات البيئية والاجتماعية والحوكمة المؤسسية المشار إليها في المساهمات المحددة وطنيًا للملكة ورؤية السعودية 2030. لذا، دمجنا الممارسات البيئية والاجتماعية والحوكمة المؤسسية في الاستراتيجية المؤسسية الشاملة لبنك الأول، والتي من شأنها أن تحدد بوصلة التنفيذ على كل مستوى من المستويات التنظيمية.",
  borderLeftBox : {
      title : "الرؤية",
      subtitle : "نأتي بعالم من الفرص المالية لمملكة طموحة",
  },
  cardsOne : [
      {
          icon : {
              name : "mobile.svg",
              alt : "",
          },
          subtitle : "تقديم تجربة مصرفية رقمية رائدة عبر الإنترنت والأجهزة النقالة",
      },
      {
          icon : {
              name : "star.svg",
              alt : "",
          },
          subtitle : "تقديم أفضل الخدمات المصرفية العالمية لكافة فئات العملاء في المملكة"
      },
      {
          icon : {
              name : "money.svg",
              alt : "",
          },
          subtitle : "أن نكون البنك الأكثر انفتاحاً على القطاع المصرفي الدولي في المملكة بفضل شراكته الاستراتيجية مع مجموعة إتش إس بي سي التي تتيح له الوصول إلى شبكة عالمية فريدة",
      },
      {
          icon : {
              name : "earth.svg",
              alt : "",
          },
          subtitle : "دمج الممارسات البيئية والاجتماعية والحوكمة المؤسسية في صميم ثقافتنا المؤسسية ما يجعل الأول المؤسسة الأكثر جاذبية لجميع أصحاب المصلحة",
      },
  ],
  paragraphTwo : 'من خلال اختيار "دمج الممارسات البيئية والاجتماعية والحوكمة المؤسسية في صميم ثقافتنا المؤسسية"، تعكس استراتيجيتنا في بنك الأول أهمية الممارسات البيئية والاجتماعية والحوكمة المؤسسية بالنسبة لجميع أصحاب المصلحة لدينا، كما توضح كيف نتفاعل مع المجتمعات وسلاسل القيمة ومساهمينا وموظفينا.',
  borderLeftTitle : "إجراءاتنا لتصدر السوق",
  cardsTwo : [
      {
          icon : {
              name : "woman.svg",
              alt : "",
          },
          title : "الاعتماد على نقاط قوتنا الرئيسية",
          list : [
              "البنك المفضل للشركات الكبرى",
              "تعزيز الريادة في التمويل التجاري والمدفوعات",
              "الحفاظ على الريادة في إدارة الثروات تعزيز مكانتنا في خدمات البطاقات",
              // "Reinforce our position in cards",
          ],
      },
      {
          icon : {
              name : "hand.svg",
              alt : "",
          },
          title : "تعزيز مشاركتنا في جوانب النمو الرئيسية",
          list : [
              "أسرع الأعمال نموًا في مجال الشركات المتوسطة",
              "التركيز على الحلول الرقمية للمنشآت المتناهية الصغر والصغيرة والمتوسطة",
              "التوسع في مجال التمويل العقاري",
              "تسجيل نمو في مجال التمويل المستدام والأصول الاستثمارية والودائع وإجمالي دخل العمليات",
          ]
      },
      {
          icon : {
              name : "earth-hand.svg",
              alt : "",
          },
          title : "تحويل المؤسسة",
          list : [
              "الريادة في مجال الابتكار الرقمي وتطوير بنية تقنية المعلومات",
              "تحويل الموارد البشرية وتطوير الكفاءات المناسبة",
              "تطوير نموذج التشغيل من خلال تعزيز إدارة البيانات والأتمتة والتحول الرقمي",
              "الالتزام بأهداف مبادرة السعودية الخضراء، ودعم مستقبل مستدام للمملكة",
          ]
      }
  ],
  timeLine : {
      title : "التخطيط طويل المدى",
      subtitle : "تمتد خططنا للممارسات البيئية والاجتماعية والحوكمة المؤسسية على المدى القصير والمتوسط والطويل، وتشمل تصميم خارطة طريق للممارسات البيئية والاجتماعية والحوكمة المؤسسية لتمهيد الطريق أمامنا وصولًا للعام 2060.",
      headers : ["2022-25", "2025", "2025-30", "2030-40", "2040-60", "2060 و/ أو ما قبله"],
      data : [
          <p><b>بناء القدرات</b></p>,
          <p><b>توفير تمويلات واستثمارات مستدامة</b> بقيمة 34 مليار ريال سعودي</p>,
          <p><b>دمج الممارسات البيئية والاجتماعية والحوكمة المؤسسية</b> على مستوى قطاعات أعمالنا ووحداتنا الوظيفية</p>,
          <p>الوصول إلى <b>المحصلة الصفرية الكربونية</b> في عملياتنا</p>,
          <p>الريادة في الطموحات وتتبعها وقياسها والإشراف عليها وإعادة تقييمها ومراجعتها</p>,
          <p>الوصول إلى <b>المحصلة الصفرية الكربونية الناتجة عن عمليات التمويل</b></p>,
      ],
      paragraph : "يتمثل طموحنا على المدى القريب في بناء القدرات المتعلقة بالتمويل المستدام وأطر عمل مخاطر المناخ والتعلم والتنمية وقطاع المصارف والشراكات للارتقاء بمسيرة عمل الأول.",
  }
};

export default businessPageDataAr